import { useMediaQuery } from '@mui/material'
import { Skeleton } from '@yuno/design-system-web'
import { AccountMenu } from '../../account-menu'

const Account = ({
  isLoadingProfile,
  accounts,
  isLoadingAccounts,
  handleSection,
  profile,
  hidden,
  handleSwitch,
  checkedSwitch,
}) => {
  const isMobile = useMediaQuery('(max-width: 599px)')

  return !isLoadingProfile && !isLoadingAccounts && accounts ? (
    <AccountMenu
      handleSwitch={handleSwitch}
      checkedSwitch={checkedSwitch}
      profile={profile}
      accounts={accounts}
      handleSection={handleSection}
      hidden={hidden}
    />
  ) : (
    <Skeleton sx={{ width: isMobile ? '50px' : '200px' }} />
  )
}

export default Account
